import * as React from 'react';
import PositionWatcher from './PositionWatcher';
import { observable } from 'mobx';
const usePositionWatcher = () => {
    const watcherRef = React.useRef();
    if (!watcherRef.current) {
        const model = observable({});
        watcherRef.current = new PositionWatcher(model);
    }
    const pw = watcherRef.current;
    React.useEffect(() => {
        // pw.watchPosition();
        return () => pw.clearWatch();
    }, []);
    return pw;
};
export default usePositionWatcher;
